module.exports = __webpack_public_path__ + "img/symbol_6.38932a5c.png";